/** Colores de Jalisco que usa la bandeja (los mismos del menú y la barra superior). */
const coloresBandeja = {
  gris: 'rgb(81, 81, 81)',
  gradiente: 'linear-gradient(90deg, #fbb040, #f15a29)',
  naranja: '#f15a29',
  primario: '#00bcd4',
  primarioClaro: '#e0f7fa',
  primarioOscuro: '#0097a7',
  borde: '#d9d9d9',
  linea: '#ececec',
  sombra: '0px 3px 6px #00000029',
  tenue: '#8a8a8a',
  secundario: '#646464',
  error: '#d32f2f',
  ok: '#2e7d32'
};

export default coloresBandeja;
